import { gql } from "@apollo/client";
import { USERTYPE } from "constants/constants";

export const getMillSettingsData = gql`
    query GetMillSettings {
        day {
            day_id
            name
            default_day_translations {
                default_day_translation_id
                language {
                    language_id
                    name
                }
                translated_name
            }
        }
        measure_metric {
            measure_metric_id
            name
            default_measure_metric_translations {
                measure_metric_id
                language {
                    language_id
                    name
                    code
                }
                translated_name
            }
        }
        key_success_factors {
            corporate_id
            key_success_factors_id
            name
            default_key_success_factor_translations {
                key_success_factor_id
                language {
                    language_id
                    name
                    code
                }
                translated_name
            }
        }
    }
`;

export const upsertMillShiftsKSFCrewsData = gql`
    mutation upsertMillShiftsKSFCrewsData(
        $shifts: [shift_insert_input!]!
        $crews: [crew_insert_input!]!
        $mill_key_success_factors: [mill_key_success_factors_insert_input!]!
        $mill_data: mill_data_insert_input!
    ) {
        insert_shift(
            objects: $shifts
            on_conflict: {
                constraint: shift_pkey
                update_columns: [name, start_time, end_time, deleted_at, disabled_at]
            }
        ) {
            affected_rows
        }
        insert_crew(objects: $crews, on_conflict: { constraint: crew_pkey, update_columns: [name, deleted_at] }) {
            affected_rows
        }
        insert_mill_key_success_factors(
            objects: $mill_key_success_factors
            on_conflict: { constraint: mill_key_success_factors_pkey, update_columns: [is_enabled] }
        ) {
            affected_rows
        }
        insert_mill_data_one(
            object: $mill_data
            on_conflict: {
                constraint: mill_data_pkey
                update_columns: [
                    language_id
                    measure_metric_id
                    timezone
                    first_day_reporting_week
                    first_day_fiscal_year
                ]
            }
        ) {
            mill_data_id
        }
    }
`;

export const insertMillWithAdminUser = gql`
    mutation registerMill($mill: mill_insert_input!) {
        insert_mill_one(object: $mill) {
            corporate_id
            name
            mill_id
            naics_code
            division_id
            region_id
            country_id
            url
            physical_address
            billing_address
            phone_number
            users {
                user_id
                first_name
                last_name
                email
            }
        }
    }
`;

export const upsertMillWithAdminUser = gql`
    mutation upsertMillWithAdminUser($mill: [mill_insert_input!]!, $user: [user_insert_input!]!) {
        insert_mill(
            objects: $mill
            on_conflict: {
                constraint: mill_pkey
                update_columns: [
                    name
                    code
                    naics_code
                    division_id
                    region_id
                    country_id
                    url
                    physical_address
                    physical_address_2
                    physical_city_name
                    physical_state_name
                    physical_zip_code
                    physical_country_id
                    billing_address
                    billing_address_2
                    billing_city_name
                    billing_state_name
                    billing_zip_code
                    billing_country_id
                    phone_number
                ]
            }
        ) {
            affected_rows
        }

        insert_user(
            objects: $user
            on_conflict: {
                constraint: user_pkey
                update_columns: [first_name, last_name, email, mill_id, corporate_id, user_type_id]
            }
        ) {
            affected_rows
        }
    }
`;

export const getMachineCentersDowntimesByMill = gql`
    query machine_centers_downtimes_by_mill($mill_id: Int!, $measure_metric_id: Int!) {
        event_reports_failure_types_stats(
            where: {
                measure_metric_id: { _eq: $measure_metric_id }
                machine_center: { production_line: { mill_id: { _eq: $mill_id } } }
            }
        ) {
            total_minutes
            total_occurrences
            measure_metric_id
            machine_center {
                name
                machine_center_id
                production_line {
                    production_line_id
                    mill_id
                }
            }
            failure_type_id
            name
            color_code
        }
    }
`;

export const getMillShifts = gql`
    query millShifts($mill_id: Int!) {
        shift(where: { mill_id: { _eq: $mill_id }, disabled_at: { _is_null: true } }) {
            shift_id
            name
            shift_historic(order_by: { effective_at: desc }, limit: 1) {
                shift_historic_id
                end_time
                start_time
                effective_at
                shift_days {
                    shift_day_id
                    day_id
                    is_enabled
                    day {
                        name
                        default_day_translations {
                            default_day_translation_id
                            language {
                                language_id
                                name
                            }
                            translated_name
                        }
                    }
                }
            }
        }
    }
`;

export const getAllMillData = gql`
    query getAllMillData($mill_id: Int!) {
        mill(where: { mill_id: { _eq: $mill_id } }) {
            mill_id
            name
            code
            physical_address
            billing_address
            url
            phone_number
            naics_code
            shifts(order_by: {created_at: desc}, where: {disabled_at: {_is_null: true}}) {
                shift_id
                name
      					shift_historic(order_by: {effective_at: desc}, limit: 1){
                  shift_historic_id
                  end_time
                  start_time
                  shift_days {
                    day_id
                    is_enabled
                    day {
                        day_id
                        name
                        default_day_translations {
                                        default_day_translation_id
                                        language {
                                            language_id
                                            name
                                        }
                                        translated_name
                                    }
                    }
                }
                }
                
            }
            mill_data {
                first_day_reporting_week
                day_reporting_week {
                  day_id
                  name
                default_day_translations {
                      default_day_translation_id
                      language {
                          language_id
                          name
                      }
                      translated_name
                  }
              }
                first_day_fiscal_year
                timezone
                language {
                    language_id
                    name
                }
            }
            corporate {
                corporate_data {
                    url
                }
            }
            division {
                division_id
                name
            }
            region {
                region_id
                name
            }
            country {
              name
              code
            }
        }
        user(where: { mill_id: { _eq: $mill_id }, user_type_id: { _eq: ${USERTYPE.ADMINISTRATOR} }, is_enabled: {_eq: true} }) {
            user_id
            first_name
            last_name
            email
        }
        day {
            day_id
            name
        }
    }
`;

export const getCorporateZipcodeAndCountry = gql`
    query getCorporateZipcodeAndCountry($mill_id: Int!) {
        mill(where: { mill_id: { _eq: $mill_id } }) {
            mill_data {
                timezone
            }
        }
        corporate {
            country {
                id
                code
            }
            zip_code
        }
    }
`;

export const getMillCountryCode = gql`
    query getMillCountryCode($mill_id: Int!) {
        mill(where: { mill_id: { _eq: $mill_id } }) {
            country {
                name
                code
            }
        }
    }
`;

export const getMillTimezone = gql`
    query getMillTimezone($mill_id: Int!) {
        mill_data(where: { mill_id: { _eq: $mill_id } }) {
            timezone
        }
    }
`;

export const isOnboardingCorporateBackoffice = gql`
    query isOnboarding {
        mill {
            mill_id
            mill_data {
                mill_data_id
            }
            shifts {
                shift_id
            }
        }
    }
`;

export const enableOrDisableMill = gql`
    mutation enableOrDisableMill($mill_id: Int!, $is_enabled: Boolean!) {
        update_mill(where: { mill_id: { _eq: $mill_id } }, _set: { is_enabled: $is_enabled }) {
            affected_rows
        }
    }
`;

export const getEventFailureCodeSummaryPerMCQuery = gql`
    query getEventFailureCodeSummaryPerMC($where: event_failure_code_summary_per_mc_bool_exp) {
        event_failure_code_summary_per_mc(where: $where) {
            created_at
            seconds
            occurrences
            measure_metric_id
            machine_center {
                machine_center_id
                name
                short_name
                production_line {
                    production_line_id
                    name
                    mill_id
                }
            }
            failure_code {
                failure_code_id
                name
                code
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
            failure_type {
                failure_type_id
                name
                color_code
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
            shift {
                shift_id
                name
            }
        }
    }
`;

export const getEventFunctionalLocationSummaryPerMCQuery = gql`
    query getEventFunctionalLocationSummaryPerMC($where: event_functional_location_summary_per_mc_bool_exp) {
        event_functional_location_summary_per_mc(where: $where) {
            created_at
            seconds
            occurrences
            measure_metric_id
            machine_center {
                machine_center_id
                name
                production_line {
                    production_line_id
                    name
                    mill_id
                }
            }
            failure_type {
                failure_type_id
                color_code
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
            functional_location {
                functional_location_id
                translation {
                    id
                    translation_names {
                        name
                        language_id
                    }
                }
            }
            shift {
                shift_id
                name
            }
        }
    }
`;

export const getMillMaximumOvertime = gql`
    query getMillMaximumOvertime($mill_id: Int!) {
        mill(where: { mill_id: { _eq: $mill_id } }) {
            maximum_overtime
        }
    }
`;

export const updateMillFeatureCluster = gql`
    mutation updateMillFeatureCluster($mill_id: Int!, $cluster_enabled: Boolean!) {
        update_mill(where: { mill_id: { _eq: $mill_id } }, _set: { cluster_enabled: $cluster_enabled }) {
            affected_rows
        }
    }
`;

export const updateMillDedicatedLocalserver = gql`
    mutation updateMillDedicatedLocalserver($mill_id: Int!, $dedicated_localserver: Boolean!) {
        update_mill(where: { mill_id: { _eq: $mill_id } }, _set: { dedicated_localserver: $dedicated_localserver }) {
            affected_rows
        }
    }
`;

export const upsertMillModule = gql`
    mutation upsertMillModule($mill_id: Int!, $module_type_id: Int!, $is_enabled: Boolean!) {
        insert_mill_modules_one(
            object: { mill_id: $mill_id, module_type_id: $module_type_id, is_enabled: $is_enabled }
            on_conflict: {
                constraint: mill_modules_mill_id_module_type_id_key
                update_columns: [is_enabled]
            }
        ) {
            id
            mill_id
            module_type_id
            is_enabled
        }
    }
`;

export const getMillLocalserverCurrentStatus = gql`
    subscription getMillLocalserverCurrentStatus($where: local_server_status_reports_bool_exp) {
        local_server_status_reports(where: $where) {
            status_id
        }
    }
`;
export interface LocalServerStatusResponse {
    local_server_status_reports: { status_id: number }[];
}

export const getMillLocalserverStatusSummary = gql`
    query getMillLocalserverStatusSummary($args: get_local_server_status_summary_args!) {
        get_local_server_status_summary(args: $args) {
            disconnected_seconds
            connected_seconds
            total_seconds
            range_end_date
            range_start_date
            total_occurrences
        }
    }
`;
export interface LocalserverStatusSummaryResponse {
    get_local_server_status_summary: {
        disconnected_seconds: number;
        connected_seconds: number;
        total_seconds: number;
        range_end_date: Date;
        range_start_date: Date;
        total_occurrences: number;
    }[];
}

export const getMillLocalserverStatusReports = gql`
    query getMillLocalserverStatusReports(
        $where: local_server_status_reports_bool_exp!
        $limit: Int!
        $offset: Int!
        $order_by: [local_server_status_reports_order_by!]
    ) {
        local_server_status_reports(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
            id
            start_date
            end_date
            duration_in_seconds
        }
    }
`;
export interface LocalserverStatusReportsResponse {
    local_server_status_reports: {
        id: number;
        duration_in_seconds: number;
        total_seconds: number;
        start_date: Date;
        end_date: Date | null;
    }[];
}
